export default __webpack_public_path__ + "static/char-s-38-en-597b737c25d2cdd5af19709ead8f867d.png";